/**
 * @generated SignedSource<<8a12953a6df5d35197c98e1c861bd087>>
 * @relayHash 8b911a50f0a9c831e5e0b32563d6a824
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8b911a50f0a9c831e5e0b32563d6a824

import { ConcreteRequest } from 'relay-runtime';
export type De_rejectPatientAsPotentialDuplicateInput = {
  patientId: string;
};
export type deRejectPatientAsPotentialDuplicateMutation$variables = {
  input: De_rejectPatientAsPotentialDuplicateInput;
};
export type deRejectPatientAsPotentialDuplicateMutation$data = {
  readonly rejectPatientAsPotentialDuplicate: {
    readonly boolean: boolean | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type deRejectPatientAsPotentialDuplicateMutation = {
  response: deRejectPatientAsPotentialDuplicateMutation$data;
  variables: deRejectPatientAsPotentialDuplicateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "boolean",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deRejectPatientAsPotentialDuplicateMutation",
    "selections": [
      {
        "alias": "rejectPatientAsPotentialDuplicate",
        "args": (v1/*:: as any*/),
        "concreteType": "De_rejectPatientAsPotentialDuplicatePayload",
        "kind": "LinkedField",
        "name": "de_rejectPatientAsPotentialDuplicate",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deRejectPatientAsPotentialDuplicateMutation",
    "selections": [
      {
        "alias": "rejectPatientAsPotentialDuplicate",
        "args": (v1/*:: as any*/),
        "concreteType": "De_rejectPatientAsPotentialDuplicatePayload",
        "kind": "LinkedField",
        "name": "de_rejectPatientAsPotentialDuplicate",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "8b911a50f0a9c831e5e0b32563d6a824",
    "metadata": {},
    "name": "deRejectPatientAsPotentialDuplicateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7c6088e4ca95a9ee1f0ae24a9a313c76";

export default node;
